import { WhatsIncludedConfig } from "./types";

export const WHATS_INCLUDED_CONFIG: WhatsIncludedConfig = {
  title: "What's included",
  subtitle: "Compare plans at a glance",
  categories: [
    {
      id: "core",
      name: "Core features",
      features: [
        {
          id: "open-banking",
          name: "Open Banking sync (TrueLayer)",
          starter: "check",
          professional: "check",
          accountant: "check",
        },
        {
          id: "csv-upload",
          name: "CSV upload",
          starter: "check",
          professional: "check",
          accountant: "check",
        },
        {
          id: "vat-detection",
          name: "Automatic VAT detection",
          starter: "check",
          professional: "check",
          accountant: "check",
        },
        {
          id: "dashboard",
          name: "Safe-to-Spend dashboard",
          starter: "check",
          professional: "check",
          accountant: "check",
        },
        {
          id: "sms",
          name: "Friday Safe-to-Spend SMS",
          starter: "check",
          professional: "check",
          accountant: "check",
        },
        {
          id: "reserve",
          name: "Reserve account tracking",
          starter: "check",
          professional: "check",
          accountant: "check",
        },
        {
          id: "confidence",
          name: "Confidence Engine (Green/Yellow/Red)",
          starter: "check",
          professional: "check",
          accountant: "check",
        },
        {
          id: "audit",
          name: "Full proof and audit trail",
          starter: "check",
          professional: "check",
          accountant: "check",
        },
        {
          id: "cancel",
          name: "Cancel anytime",
          starter: "check",
          professional: "check",
          accountant: "check",
        },
      ],
    },
    {
      id: "integrations",
      name: "Integrations",
      features: [
        {
          id: "xero",
          name: "Xero sync",
          starter: "empty",
          professional: "check",
          accountant: "check",
        },
        {
          id: "quickbooks",
          name: "QuickBooks sync",
          starter: "empty",
          professional: "check",
          accountant: "check",
        },
        {
          id: "stripe",
          name: "Stripe import",
          starter: "empty",
          professional: "check",
          accountant: "check",
        },
        {
          id: "paypal",
          name: "PayPal import",
          starter: "empty",
          professional: "check",
          accountant: "check",
        },
        {
          id: "card",
          name: "Card transaction import",
          starter: "empty",
          professional: "check",
          accountant: "check",
        },
      ],
    },
    {
      id: "delivery",
      name: "Delivery",
      features: [
        {
          id: "whatsapp-msg",
          name: "Friday WhatsApp message",
          starter: "empty",
          professional: "check",
          accountant: "check",
        },
        {
          id: "whatsapp-queries",
          name: "Inbound WhatsApp queries",
          starter: "empty",
          professional: "check",
          accountant: "check",
        },
        {
          id: "daily-updates",
          name: "Daily Safe-to-Spend updates",
          starter: "empty",
          professional: "check",
          accountant: "check",
        },
      ],
    },
    {
      id: "reporting",
      name: "Reporting",
      features: [
        {
          id: "confidence-history",
          name: "Confidence history",
          starter: "empty",
          professional: "check",
          accountant: "check",
        },
        {
          id: "vat-health",
          name: "VAT Cash Health Report",
          starter: "empty",
          professional: "empty",
          accountant: "check",
        },
      ],
    },
    {
      id: "organisations",
      name: "Organisations",
      features: [
        {
          id: "client-orgs",
          name: "Client organisations",
          starter: "1",
          professional: "1",
          accountant: "Up to 20",
        },
        {
          id: "dashboard-partner",
          name: "Partner dashboard",
          starter: "empty",
          professional: "empty",
          accountant: "check",
        },
        {
          id: "bulk-csv",
          name: "Bulk CSV import",
          starter: "empty",
          professional: "empty",
          accountant: "check",
        },
        {
          id: "client-overview",
          name: "Client overview",
          starter: "empty",
          professional: "empty",
          accountant: "check",
        },
        {
          id: "commission",
          name: "Accountant referral commission",
          starter: "empty",
          professional: "empty",
          accountant: "20%",
        },
      ],
    },
    {
      id: "support",
      name: "Support",
      features: [
        {
          id: "email",
          name: "Email support",
          starter: "check",
          professional: "check",
          accountant: "check",
        },
        {
          id: "priority",
          name: "Priority support",
          starter: "empty",
          professional: "check",
          accountant: "check",
        },
        {
          id: "phone",
          name: "Priority phone support",
          starter: "empty",
          professional: "empty",
          accountant: "check",
        },
        {
          id: "early-access",
          name: "Early access to new features",
          starter: "empty",
          professional: "empty",
          accountant: "check",
        },
      ],
    },
  ],
};
